module.exports = __webpack_public_path__ + "media/img/home/bg-home-9e1b5e8e59cde9f77096dff1fd55ecdc.png";